import { call } from 'redux-saga/effects';

import api from 'api';

import { sendRetenoAnalyticsRequest } from 'store/analytics/actions';

export function* sendRetenoAnalytics({ payload }: ReturnType<typeof sendRetenoAnalyticsRequest>) {
    try {
        yield call(api.analytics.sendRetenoAnalyticsEvent, payload);
        yield call(sendRetenoAnalyticsRequest, payload);
    } catch (error: any) {
        console.error(`Reteno event has not been sent due to the error: ${error?.message}`);
    }
}
